import React, { useEffect } from 'react';

function Contact() {

  useEffect(() => {
    document.title = "Contact";
  }, []);

    return (
      <div className="container">
        <h1>Contact</h1>
        <p style={{ textAlign: "center", lineHeight: "1.3" }}>
          If you spotted any errors, have suggestions, or
          request for new pages, I'd love to hear them!
        </p>
        <hr></hr>
        <div className="form-container">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSciOiLufFhAqx9lDhi6NVYB-3urs2xW0T4tP9t8xytaIihDjw/viewform?embedded=true"
            width="640"
            height="480"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          >
            Loading…
          </iframe>
        </div>
      </div>
    );
}

export default Contact;